/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pxk_Sorting_Notes_TitleInputs */

const vi_pl_pxk_sorting_notes_title = /** @type {(inputs: Pl_Pxk_Sorting_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu nhập kho phân loại từ phiếu này`)
};

/**

* @param {Pl_Pxk_Sorting_Notes_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pxk_sorting_notes_title = /** @type {((inputs?: Pl_Pxk_Sorting_Notes_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pxk_Sorting_Notes_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pxk_sorting_notes_title(inputs)
});